module.exports = __webpack_public_path__ + "img/bg-gradient.ff5b858a.png";